
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/dynamic-breadcrumbs.kpa`,
      template: `<nav class="dynamic-breadcrumbs">
        <ul>
            <li loop="crumb in breadcrumbs">
                <a href="{{crumb.href}}" onClick="navigateTo">
                    {{crumb.label}}
                </a>
            </li>
        </ul>
    </nav>`,
      style: `dynamic-breadcrumbs .dynamic-breadcrumbs {
  margin: 0;
  padding: 0;
}
dynamic-breadcrumbs .dynamic-breadcrumbs .wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0;
}
dynamic-breadcrumbs .dynamic-breadcrumbs ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}
dynamic-breadcrumbs .dynamic-breadcrumbs ul li {
  margin: 0 8px 0 0;
  list-style-type: none;
}
dynamic-breadcrumbs .dynamic-breadcrumbs ul li a {
  text-decoration: none;
  color: #2c4143;
  font-weight: bold;
  font-size: 14px;
}
dynamic-breadcrumbs .dynamic-breadcrumbs ul li a:hover {
  color: #64c16c;
}
dynamic-breadcrumbs .dynamic-breadcrumbs ul li:not(:last-child)::after {
  content: "/";
  margin-left: 8px;
  color: #aaa;
  font-size: 16px;
}
dynamic-breadcrumbs .dynamic-breadcrumbs ul li:last-child a {
  text-decoration: underline;
}
@media (max-width: 360px) {
  dynamic-breadcrumbs .dynamic-breadcrumbs ul li a {
    font-size: 12px;
  }
  dynamic-breadcrumbs .dynamic-breadcrumbs ul li:not(:last-child)::after {
    margin-left: 4px;
    font-size: 14px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        breadcrumbs: [],
    },
    methods: {
        generateBreadcrumbs(url) {
            const segments = url.split('/').filter(segment => segment);
            const breadcrumbs = segments.map((segment, index) => {
                const path = '/' + segments.slice(0, index + 1).join('/');
                return {
                    label: router.getRouteMeta(path).label || this.formatLabel(segment),
                    href: path,
                };
            });
            breadcrumbs.unshift({
                label: '<i class="fa-solid fa-house"></i>',
                href: '/home',
            });
            this.breadcrumbs = breadcrumbs;
        },
        formatLabel(segment) {
            if (typeof segment !== 'string') {
                console.error('Invalid segment:', segment);
                return '';
            }
            return segment
                .replace(/-/g, ' ')
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        },
        navigateTo(event) {
            event.preventDefault();
            const href = event.target.closest('a').getAttribute('href');
            router.navigate(href);
            this.generateBreadcrumbs(href);
        },
    },
    events: [
        ['popstate', window, function () {
                this.generateBreadcrumbs(window.location.pathname);
            }],
    ],
    created() {
        this.generateBreadcrumbs(window.location.pathname);
    },
};
 })()`
    };
  